import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WorkDaysPage } from './work-days';

@NgModule({
  declarations: [
    WorkDaysPage,
  ],
  imports: [
    IonicPageModule.forChild(WorkDaysPage),
  ],
})
export class WorkDaysPageModule {}



// WEBPACK FOOTER //
// ./src/pages/work-days/work-days.module.ts